import { NgModule } from '@angular/core';

import { SpectrumScannerApiService } from '../api';

import { SysApiSpectrumScannerApiService } from './sys-api-spectrum-scanner-api.service';

@NgModule({
	providers: [
		SysApiSpectrumScannerApiService,
		{
			provide: SpectrumScannerApiService,
			useClass: SysApiSpectrumScannerApiService
		}
	]
})
export class SysApiSpectrumScannerDataAccessModule {}
